import { defineMessages } from 'react-intl';

export default defineMessages({
  newbie: {
    id: 'app.components.PublisherExperienceTag.newbie',
    defaultMessage: 'Newbie',
  },
  mentor: {
    id: 'app.components.PublisherExperienceTag.mentor',
    defaultMessage: 'Mentor',
  },
});
